<template>
  <div class="chart-container">
    <div class="chart-header">
      <border-box :message="title"></border-box>
      <div class="unit" v-if="unit !== ''">{{unit}}</div>
    </div>
    <div :style="chartStyle" id="left_bottom_chart">
    </div>
  </div>
</template>

<script>
import { selectCategory } from '@/api/dataview/repairAmount'
import BorderBox from '../border/BorderBox'
var echartsMap
export default {
  name: 'RepairAmount1',
  components: { BorderBox },
  props: ['title', 'unit'],
  data () {
    return {
      chartStyle: { width: '100%', height: '100%' }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      var that = this
      echartsMap = that.$echarts.init(document.getElementById('left_bottom_chart'))
      var param = {}
      selectCategory(param).then(res => {
        if (res.code === 200) {
          var pieData = []
          var pieCount = 0
          for (var j = 0; j < res.data.length; j++) {
            var json = {}
            json.name = res.data[j].categoryName.replace("系统","")
            json.value = res.data[j].total
            json.online = res.data[j].online
            pieData.push(json)
            pieCount = pieCount + res.data[j].total
          }

          var option = {
            tooltip: {
              trigger: 'none'
            },
            grid: {
              top: '1%',
              left: '2%',
              right: '3%',
              containLabel: true
            },
            legend: {
              type: 'plain',
              show: true,
              orient: 'vertical',
              right: 10,
              top: '15%',
              bottom: '10%',
              icon: 'circle',
              itemHeight: 3,
              align: 'left',
              padding: [0, 0, 1, 0],
              width: '55%',
              textStyle: {
                color: '#88e3ff',
                fontSize: 12,
                overflow: 'truncate',
                width: 110,
                rich: {
                  a: {
                    align: 'left',
                    fontSize: 12
                  },
                  b: {
                    align: 'right',
                    fontSize: 12
                  }
                }
              },
              formatter (name) {
                // const count = pieCount
                const val = pieData.filter(item => {
                  // console.log(item)
                  return item.name === name
                })
                return '{a|' + name + ' ' + '}' + '{b|' + ((val[0].online / val[0].value) * 100).toFixed(1) + '%/' + val[0].value + '}'
              }
            },
            series: [{
              name: '',
              type: 'pie',
              radius: ['70%', '50%'],
              avoidLabelOverlap: false,
              width: '45%',
              data: pieData,
              label: {// 饼图图像文本标签
                position: 'center',
                fontSize: '12px',
                formatter: function () {
                  let count = pieCount
                  let str = '{a|安装总量}' + '\n' + '{b|' + count + '}'
                  return str
                },
                rich: {// 富文本样式
                  a: {
                    color: '#88e3ff',
                    fontSize: '12px'
                  },
                  b: {
                    color: '#66FFCC',
                    //fontWeight: 'bold',
                    fontSize: '12px'
                  }
                }

              }
            }]
          }
          echartsMap.setOption(option)
          window.addEventListener("resize", function() {
            echartsMap.resize();
          });
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .chart-container
    display flex
    flex-direction column
    // border 1px solid rgba(14, 101, 187, 0.66);
    height calc(100%)
    .chart-header
      display flex
      // border-box
      //   flex-grow auto
      justify-content space-between
      .unit
        width 60px
        margin-right 8px
        line-height 30px
        font-size 15px
        font-family Microsoft YaHei
        font-weight 400
        color white

</style>
